import { useState } from "react";
import styles from "./index.module.scss";

export default function AdminTable({ items }) {
  const [searchValue, setSearchValue] = useState("");

  const filteredItems = items.filter((item) =>
    item.phone.includes(searchValue)
  );

  return (
    <>
      <div className={styles.searchBox}>
        <div>
          <i></i>
        </div>
        <input
          type="text"
          placeholder="Search..."
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>
      <div className={styles.content}>
        {filteredItems.map((item, index) => (
          <div className={styles.phone} key={index}>
            {item.phone}
          </div>
        ))}
      </div>
    </>
  );
}
